import { isNilOrNaN } from '@yoop/util';

export const isNilOrZero = (value: number): boolean => isNilOrNaN(value) || value === 0;
